module.exports = __webpack_public_path__ + "img/taken_stocks.474f16f9.svg";